import {AbstractModel, JsonObject, JsonProperty} from 'projects/core/src/public-api';
import {ProjectStatus} from '../../project-misc/data/project/statuses/project-status';

@JsonObject('model.ActivityDurationId')
export class ActivityDurationId extends AbstractModel {
  @JsonProperty(Number, 'complexityId')
  complexityId: number;

  @JsonProperty(Number, 'typeId')
  typeId: number;
}

@JsonObject('model.ActivityDuration')
export class ActivityDuration extends AbstractModel {

  @JsonProperty(ActivityDurationId, 'id')
  id?: ActivityDurationId;

  @JsonProperty(Number, 'hours')
  hours: number;

  @JsonProperty(Number, 'hoursWA')
  hoursWA: number;

  @JsonProperty(ProjectStatus, 'complexity')
  complexity?: ProjectStatus;
}
